import { useMediaQuery } from '../../MediaQuery'
import { type Themeable, useThemeable } from '../../themeable'
import type { AnimationProps } from '../../useKeyedAnimation'
import { Card } from '../Card/Card'
import type { DefaultContent } from '../DefaultContent'
import { PullUp } from '../PullUp/PullUp'
import type { Options } from './Options'

type Props = DefaultContent &
	AnimationProps & {
		themeableOptions: Themeable<Options>
	}

export const HybridCard = ({ themeableOptions, ...rest }: Props) => {
	const { mobileMediaQueryName, ...options } = useThemeable(themeableOptions)
	const isMobile = useMediaQuery(mobileMediaQueryName)

	if (isMobile) {
		return <PullUp themeableOptions={options} {...rest} />
	}
	return <Card themeableOptions={options} {...rest} />
}
